import React, { forwardRef } from "react";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";
import { Skeleton, SkeletonProps } from "@mui/material";

interface CSkelotonProps extends SkeletonProps {
  sx?: SxProps;
}

const defaultSx: SxProps<Theme> = {
  backgroundColor: "#e4edf2",
  "&::after": {
    background: "linear-gradient(90deg, #e4edf2, #ffffff, #e4edf2)",
  },
};
const CSkeleton = forwardRef<HTMLDivElement, CSkelotonProps>((props, ref) => {
  const { variant, sx, children, ...otherProps } = props;

  return (
    <Skeleton
      ref={ref}
      {...otherProps}
      animation={"wave"}
      sx={{
        ...defaultSx,
        ...sx, // Allow custom sx to override the default styles
      }}
    >
      {children}
    </Skeleton>
  );
});

export default CSkeleton;
